import { db, firebase } from "../../../config/firebase/firebase-config";
import { IResponseFirebase } from "../../../interfaces/firebase";
import {
  ITrdDocumentalType,
  ITrdVersion,
  IFiles,
} from "../../../redux/types/types";

export const getTrdVersions = async (
  idEntity: string
): Promise<ITrdVersion[]> => {
  const versionsSnap = await db
    .collection("Entities")
    .doc(idEntity)
    .collection("TRD")
    .orderBy("approvalDate", "desc")
    .get();
  const versions: ITrdVersion[] = [];
  versionsSnap.forEach((doc) => {
    versions.push(doc.data() as ITrdVersion);
  });
  return versions;
};

export const deleteTrdVersion = async (
  idEntity: string,
  idVersion: string
): Promise<IResponseFirebase> => {
  try {
    const docRef = db.collection("Entities").doc(idEntity);
    const snapOp = await docRef.collection("ProductionOffices").limit(1).get();
    if (snapOp.empty) {
      return {
        ok: false,
      };
    }
    await docRef.collection("TRD").doc(idVersion).delete();
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};
export const addOrUpdateSupportDocuments = async (
  idEntity: string,
  idVersion: string,
  docs: IFiles[]
) => {
  try {
    await db
      .collection("Entities")
      .doc(idEntity)
      .collection("TRD")
      .doc(idVersion)
      .set(
        {
          supportDocs: docs.length > 0 ? docs : null,
        },
        {
          merge: true,
        }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};
export const deleteFileSupportDocument = async (
  idVersion: string,
  fileName: string
): Promise<IResponseFirebase> => {
  try {
    await firebase
      .storage()
      .ref(`/supportDocuments/${idVersion}/${fileName}`)
      .delete();
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// --------------------------------------------------------
// --------------- OFICINAS PRODUCTORAS -------------------
// --------------------------------------------------------

// Cargar oficinas Productoras
export const loadProductionOffices = async (idEntity: string) => {
  const productionOfficesSnap = await db
    .collection(`/Entities/${idEntity}/ProductionOffices`)
    .get();
  const productionOffices: any = [];

  productionOfficesSnap.forEach((snapChild) => {
    productionOffices.push({
      id: snapChild.id,
      ...snapChild.data(),
    });
  });
  return productionOffices;
};

// Actualizar array de oficinas productoras en TRD versión
export const updateArrayProductionOffices = async (
  idEntity: string,
  idVersion: string,
  offices: string[]
) => {
  try {
    await db
      .collection("Entities")
      .doc(idEntity)
      .collection("TRD")
      .doc(idVersion)
      .set(
        {
          productionOffices: offices.length > 0 ? offices : null,
        },
        {
          merge: true,
        }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Eliminar oficina productora
// Eliminar encuestas tranasmitidas



//DOCUMENTAL TYPES
export const loadTrdDocumentalTypes = async (
  idEntity: string
): Promise<ITrdDocumentalType[] | null> => {
  const snap = await db
    .collection("Entities")
    .doc(idEntity)
    .collection("DocumentalTypes")
    .get();
  if (snap.empty) {
    return null;
  }
  const response: ITrdDocumentalType[] = [];
  snap.forEach((doc) => {
    response.push(doc.data() as ITrdDocumentalType);
  });
  return response;
};
export const setTrdDocumentalType = async (
  idEntity: string,
  documentalType: ITrdDocumentalType,
  documentalArr: any
): Promise<IResponseFirebase> => {
  try {
    const docRef = db.collection("Entities").doc(idEntity);

    await docRef
      .collection("DocumentalTypes")
      .doc(documentalType.idDocumentalType)
      .set({
        ...documentalType,
        createAt: firebase.firestore.Timestamp.now(),
      });
    await docRef
      .collection("TRD")
      .doc(documentalType.idVersion)
      .set(
        {
          documentalType: documentalArr.length > 0 ? documentalArr : null,
        },
        { merge: true }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

export const deleteTrdDocumentalType = async (
  idEntiy: string,
  idDocumentalType: string,
  fileName: string,
  idVersion: string,
  documetalTypesToTrd: string[]
): Promise<IResponseFirebase> => {
  try {
    const docRef = db.collection("Entities").doc(idEntiy);
    await docRef.collection("DocumentalTypes").doc(idDocumentalType).delete();
    await firebase
      .storage()
      .ref(`/documentalType/${idVersion}/${fileName}`)
      .delete();
    await docRef
      .collection("TRD")
      .doc(idVersion)
      .set(
        {
          documentalType:
            documetalTypesToTrd.length > 0 ? documetalTypesToTrd : null,
        },
        { merge: true }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};
